module.exports = __webpack_public_path__ + "c05f5b8410202a9607f5cf74e4bc5742.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/billstatus.png
// module id = 737
// module chunks = 0